(function () {
  'use strict';

  var SVG_CHECK =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"' +
    ' class="mod_app_js_components_add_to_cart_button_CBbO3G_AddToCart_icon"' +
    ' style="width:1em;height:1em;vertical-align:middle;margin-right:.4em">' +
    '<path d="M10.5616 15.9077L16.9577 9.51155L16.25 8.80385L10.5616 14.4923L7.71155' +
    ' 11.6423L7.00385 12.35L10.5616 15.9077ZM12.0034 21C10.7588 21 9.58872 20.7638' +
    ' 8.4931 20.2915C7.39748 19.8192 6.44444 19.1782 5.63397 18.3685C4.82352 17.5588' +
    ' 4.18192 16.6066 3.70915 15.512C3.23638 14.4174 3 13.2479 3 12.0033C3 10.7588' +
    ' 3.23616 9.58872 3.70848 8.4931C4.18081 7.39748 4.82183 6.44444 5.63153 5.63398' +
    'C6.44123 4.82353 7.39337 4.18192 8.48795 3.70915C9.58255 3.23638 10.7521 3' +
    ' 11.9966 3C13.2412 3 14.4113 3.23616 15.5069 3.70848C16.6025 4.18081 17.5556' +
    ' 4.82182 18.366 5.63152C19.1765 6.44122 19.8181 7.39337 20.2908 8.48795C20.7636' +
    ' 9.58255 21 10.7521 21 11.9967C21 13.2412 20.7638 14.4113 20.2915 15.5069' +
    'C19.8192 16.6025 19.1782 17.5556 18.3685 18.366C17.5588 19.1765 16.6066 19.8181' +
    ' 15.512 20.2908C14.4174 20.7636 13.2479 21 12.0034 21Z" fill="#f1f1f1"/></svg>';

  window.MWUpsellEngine = {

    promos: [],

    _injectTimer: null,
    _cartPageTimer: null,


    init: function () {
      this._setupDrawerObserver();

      var dataEl = document.getElementById('MWUpsellPromos');
      if (!dataEl) return;

      try {
        this.promos = JSON.parse(dataEl.textContent || dataEl.innerHTML);
      } catch (e) {
        console.error('[MWUpsell] Failed to parse promo data:', e);
        return;
      }

      if (!this.promos.length) return;

      this._setupCartPageObserver();
      this.injectProductCardPills();
    },


    _setupDrawerObserver: function () {
      var self = this;
      var drawerProducts = document.querySelector('#CartDrawer [data-products]');
      if (!drawerProducts) return;

      var observer = new MutationObserver(function () {
        clearTimeout(self._injectTimer);
        self._injectTimer = setTimeout(function () {
          if (self.promos.length) {
            self.injectDrawerOffer();
          }
        }, 60);
      });

      observer.observe(drawerProducts, { childList: true });
    },


    _setupCartPageObserver: function () {
      var self = this;
      var pageProducts = document.querySelector('#CartPageForm [data-products]');
      if (!pageProducts) return;

      var observer = new MutationObserver(function () {
        clearTimeout(self._cartPageTimer);
        self._cartPageTimer = setTimeout(function () {
          self._updateCartPagePromoVisibility();
        }, 60);
      });

      observer.observe(pageProducts, { childList: true });
    },

    _updateCartPagePromoVisibility: function () {
      var self = this;
      var offerSection = document.querySelector('.mw-offers-section--cart');
      if (!offerSection) return;

      this._getCart().then(function (cart) {
        var productIds = cart.items.map(function (item) { return item.product_id; });
        var promos = self.findMatchingPromos(productIds);
        if (!promos.length) {
          offerSection.style.display = 'none';
        }
      });
    },


    _updateCartPageSummary: function () {
      var summaryPanel = document.querySelector('#CartPageForm .mw-cart-summary-panel');
      if (!summaryPanel) return;

      var cartItemsEl = document.querySelector('#CartPageForm [data-products] .cart__items');
      if (!cartItemsEl) return;

      var totalDiscounts = parseInt(cartItemsEl.dataset.cartSavings || 0, 10);

      var items = cartItemsEl.querySelectorAll('.cart__item[data-key]');
      var fullSubtotal = 0;
      var compareSavings = 0;
      items.forEach(function (el) {
        var originalPrice  = parseInt(el.dataset.originalPrice  || 0, 10);
        var compareAtPrice = parseInt(el.dataset.compareAtPrice || 0, 10);
        var qty            = parseInt(el.dataset.quantity       || 1, 10);
        var itemBase = (compareAtPrice > originalPrice) ? compareAtPrice : originalPrice;
        if (compareAtPrice > originalPrice) {
          compareSavings += (compareAtPrice - originalPrice) * qty;
        }
        fullSubtotal += itemBase * qty;
      });

      var fmt = function (cents) {
        var moneyFormat = window.theme && theme.settings && theme.settings.moneyFormat;
        return moneyFormat
          ? MWUpsellEngine._formatMoney(cents, moneyFormat)
          : '$' + (cents / 100).toFixed(2);
      };

      var ovVal = summaryPanel.querySelector('[data-order-value] .mw-summary-value');
      if (ovVal) ovVal.textContent = fmt(fullSubtotal);

      var tdRow = summaryPanel.querySelector('[data-total-discounts]');
      if (tdRow) {
        var tdVal = tdRow.querySelector('.mw-summary-value');
        if (tdVal) tdVal.textContent = '-' + fmt(totalDiscounts);
        tdRow.style.display = totalDiscounts > 0 ? '' : 'none';
      }

      var csRow = summaryPanel.querySelector('[data-compare-savings]');
      if (csRow) {
        var csVal = csRow.querySelector('.mw-summary-value');
        if (csVal) csVal.textContent = '-' + fmt(compareSavings);
        csRow.style.display = compareSavings > 0 ? '' : 'none';
      }

      var subtotalEl = summaryPanel.querySelector('[data-subtotal]');
      if (subtotalEl) {
        var subtotal = parseInt(cartItemsEl.dataset.cartSubtotal || 0, 10);
        subtotalEl.textContent = fmt(subtotal);
      }
    },


    injectProductCardPills: function () {
      var pillMap = {};
      for (var i = 0; i < this.promos.length; i++) {
        var promo = this.promos[i];
        if (!promo.pill_label) continue;
        for (var j = 0; j < promo.trigger_product_ids.length; j++) {
          var pid = promo.trigger_product_ids[j];
          if (!pillMap[pid]) {
            pillMap[pid] = promo.pill_label;
          }
        }
      }

      var cards = document.querySelectorAll('[data-product-id]');
      for (var k = 0; k < cards.length; k++) {
        var card = cards[k];
        var productId = parseInt(card.dataset.productId, 10);
        if (!pillMap[productId]) continue;

        var pillsContainer = card.querySelector('.grid-product__pills');
        if (!pillsContainer) continue;

        var pill = document.createElement('div');
        pill.className = 'grid-product__tag grid-product__tag--offer';
        pill.textContent = pillMap[productId];
        pillsContainer.appendChild(pill);
      }
    },


    findMatchingPromos: function (cartProductIds) {
      var matching = [];

      for (var i = 0; i < this.promos.length; i++) {
        var promo = this.promos[i];
        for (var j = 0; j < promo.trigger_product_ids.length; j++) {
          if (cartProductIds.indexOf(promo.trigger_product_ids[j]) !== -1) {
            matching.push(promo);
            break;
          }
        }
      }

      matching.sort(function (a, b) { return b.priority - a.priority; });
      return matching;
    },


    injectDrawerOffer: function () {
      var self = this;
      var slot = document.getElementById('CartDrawerUpsell');
      if (!slot) return;

      this._getCart().then(function (cart) {
        if (!cart.item_count) {
          slot.style.display = 'none';
          return;
        }

        var productIds = cart.items.map(function (item) { return item.product_id; });
        var promos = self.findMatchingPromos(productIds);

        if (!promos.length) {
          slot.style.display = 'none';
          return;
        }

        slot.innerHTML = self._buildCarouselHTML(promos, cart);
        slot.style.display = 'block';
        self._bindDrawerOfferButtons(slot);
        self._bindCarouselNav(slot);
      }).catch(function (err) {
        console.error('[MWUpsell] injectDrawerOffer failed:', err);
      });
    },

    _buildCarouselHTML: function (promos, cart) {
      var h = this._esc.bind(this);

      var html = '<div class="mw-offers-section mw-offers-section--drawer">';

      html += '<div class="mw-offers-header">';
      html += '<span class="mw-offers-title">MY OFFERS</span>';
      html += '<div class="mw-offers-nav">';
      html += '<button type="button" class="mw-offers-nav-btn mw-carousel-prev" aria-label="Previous">&#8249;</button>';
      html += '<button type="button" class="mw-offers-nav-btn mw-carousel-next" aria-label="Next">&#8250;</button>';
      html += '</div>';
      html += '</div>';

      html += '<div class="mw-offers-track">';

      var cartVariantIds = cart.items.map(function (item) { return item.variant_id; });

      for (var pi = 0; pi < promos.length; pi++) {
        var promo = promos[pi];

        var triggerLineKeys = [];
        for (var ci = 0; ci < cart.items.length; ci++) {
          var item = cart.items[ci];
          if (promo.trigger_product_ids.indexOf(item.product_id) !== -1) {
            triggerLineKeys.push(item.key);
          }
        }

        var badgeClass, badgeLabel;
        if (promo.type === 'upsell') {
          badgeClass = 'mw-offer-badge--addon';
          badgeLabel = 'ADD ON';
        } else if (promo.type === 'free_gift') {
          badgeClass = 'mw-offer-badge--free';
          badgeLabel = 'FREE';
        } else {
          badgeClass = 'mw-offer-badge--upgrade';
          badgeLabel = 'UPGRADE';
        }

        for (var oi = 0; oi < promo.offer_products.length; oi++) {
          var p = promo.offer_products[oi];

          html += '<div class="mw-offer-card"';
          html += ' data-promo-id="' + h(promo.id) + '"';
          html += ' data-promo-type="' + h(promo.type) + '">';

          if (p.image) {
            html += '<div class="mw-offer-card__img-wrap">';
            html += '<img src="' + h(p.image) + '" alt="' + h(p.title) + '" loading="lazy">';
            html += '</div>';
          }

          html += '<div class="mw-offer-card__info">';
          var pillLabel = promo.badge_label || badgeLabel;
          html += '<span class="mw-offer-badge ' + badgeClass + '">' + h(pillLabel) + '</span>';
          html += '<div class="mw-offer-card__tagline">' + h(promo.tagline || '') + '</div>';
          html += '<div class="mw-offer-card__title">' + h(p.title) + '</div>';

          html += '<div class="mw-offer-card__bottom">';
          html += '<div class="mw-offer-card__price">';
          if (promo.discount_percentage > 0) {
            var discountedCents = Math.round(p.price * (100 - promo.discount_percentage) / 100);
            var moneyFormat = window.theme && theme.settings && theme.settings.moneyFormat;
            var discountedFormatted = promo.discount_percentage === 100
              ? 'Free'
              : (moneyFormat ? MWUpsellEngine._formatMoney(discountedCents, moneyFormat) : '$' + (discountedCents / 100).toFixed(2));
            html += '<s class="mw-upsell-price--original">' + h(p.price_formatted) + '</s> ';
            html += '<span class="mw-upsell-price--discounted">' + h(discountedFormatted) + '</span>';
          } else {
            html += h(p.price_formatted);
          }
          html += '</div>';

          if (promo.type === 'upgrade') {
            html += '<button type="button" class="btn btn--secondary mw-upsell-btn mw-upgrade-btn"';
            html += ' data-offer-variant-id="' + p.default_variant_id + '"';
            html += ' data-trigger-line-keys="' + h(triggerLineKeys.join(',')) + '">';
            html += h(promo.cta_label);
            html += '</button>';
          } else {
            var alreadyInCart = cartVariantIds.indexOf(p.default_variant_id) !== -1;
            if (alreadyInCart) {
              html += '<button type="button" class="btn btn--secondary mw-upsell-btn added" disabled>';
              html += SVG_CHECK + 'Added';
              html += '</button>';
            } else {
              html += '<button type="button" class="btn btn--secondary mw-upsell-btn mw-add-btn"';
              html += ' data-variant-id="' + p.default_variant_id + '">';
              html += h(promo.cta_label);
              html += '</button>';
            }
          }

          html += '</div>';
          html += '</div>';
          html += '</div>';
        }
      }

      html += '</div>';
      html += '</div>';
      return html;
    },

    _bindCarouselNav: function (container) {
      var track = container.querySelector('.mw-offers-track');
      var prev = container.querySelector('.mw-carousel-prev');
      var next = container.querySelector('.mw-carousel-next');
      if (!track || !prev || !next) return;

      var cardWidth = function () {
        var c = track.querySelector('.mw-offer-card');
        return c ? c.offsetWidth + 10 : 180;
      };

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });
    },

    _bindDrawerOfferButtons: function (slot) {
      var self = this;

      slot.querySelectorAll('.mw-add-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var variantId = parseInt(btn.dataset.variantId, 10);
          var originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = '\u2026';

          self._addToCart(variantId).then(function () {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product: { product_id: variantId }, _mwOffer: true }
            }));
          }).catch(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          });
        });
      });

      slot.querySelectorAll('.mw-upgrade-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var offerVariantId = parseInt(btn.dataset.offerVariantId, 10);
          var triggerLineKeys = btn.dataset.triggerLineKeys ? btn.dataset.triggerLineKeys.split(',').filter(Boolean) : [];
          var originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = '\u2026';

          self._handleUpgrade(triggerLineKeys, offerVariantId, 'drawer')
            .catch(function () {
              btn.disabled = false;
              btn.textContent = originalText;
            });
        });
      });
    },


    initCartPageOffer: function () {
      var self = this;
      var offerSection = document.querySelector('.mw-offers-section--cart');
      if (!offerSection) return;

      offerSection.querySelectorAll('.mw-add-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var variantId = parseInt(btn.dataset.variantId, 10);
          var originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = '\u2026';

          self._addToCart(variantId)
            .then(function () { return self._updateCartPageDOM(); })
            .then(function () {
              btn.innerHTML = SVG_CHECK + 'Added';
              btn.classList.add('added');
              if (window.MWCartUI) window.MWCartUI._initCartPageRemoveLinks();
              self._updateCartPageSummary();
            })
            .catch(function () {
              btn.disabled = false;
              btn.textContent = originalText;
            });
        });
      });

      offerSection.querySelectorAll('.mw-upgrade-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var offerVariantId = parseInt(btn.dataset.offerVariantId, 10);
          var triggerLineKeys = btn.dataset.triggerLineKeys ? btn.dataset.triggerLineKeys.split(',').filter(Boolean) : [];
          var originalText = btn.textContent;
          btn.disabled = true;
          btn.textContent = '\u2026';

          self._handleUpgrade(triggerLineKeys, offerVariantId, 'cart-page')
            .catch(function () {
              btn.disabled = false;
              btn.textContent = originalText;
            });
        });
      });

      this._sortCartPageOffers();
      this._bindCarouselNav(offerSection);
    },

    _sortCartPageOffers: function () {
      var track = document.querySelector('.mw-offers-section--cart .mw-offers-track');
      if (!track) return;

      var cards = Array.prototype.slice.call(track.querySelectorAll('.mw-offer-card'));
      cards.sort(function (a, b) {
        var pa = parseInt(a.dataset.promoPriority, 10) || 0;
        var pb = parseInt(b.dataset.promoPriority, 10) || 0;
        return pb - pa;
      });

      for (var i = 0; i < cards.length; i++) {
        track.appendChild(cards[i]);
      }
    },


    _handleUpgrade: function (triggerLineKeys, offerVariantId, context) {
      var self = this;

      var removeAll = triggerLineKeys.reduce(function (p, key) {
        return p.then(function () { return self._removeFromCart(key); });
      }, Promise.resolve());

      return removeAll
        .then(function () { return self._addToCart(offerVariantId); })
        .then(function () {
          if (context === 'drawer') {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product: { product_id: offerVariantId }, _mwOffer: true }
            }));
          } else {
            window.location.reload();
          }
        });
    },


    _updateCartPageDOM: function () {
      var cartUrl = (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
      var url = cartUrl + (cartUrl.indexOf('?') === -1 ? '?' : '&') + 'view=ajax&t=' + Date.now();

      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var temp = document.createElement('div');
          temp.innerHTML = text;
          var items = temp.querySelector('.cart__items');
          if (!items) return;

          var productsEl = document.querySelector('#CartPageForm [data-products]');
          if (productsEl) {
            productsEl.innerHTML = '';
            productsEl.appendChild(items);
          }

          var subtotal = parseInt(items.dataset.cartSubtotal || '0', 10);
          var subtotalEl = document.querySelector('#CartPageForm [data-subtotal]');
          if (subtotalEl) {
            var moneyFormat = window.theme && theme.settings && theme.settings.moneyFormat;
            subtotalEl.innerHTML = moneyFormat
              ? MWUpsellEngine._formatMoney(subtotal, moneyFormat)
              : '$' + (subtotal / 100).toFixed(2);
          }
        });
    },


    _formatMoney: function (cents, format) {
      if (typeof Currency !== 'undefined' && Currency.formatMoney) {
        return Currency.formatMoney(cents, format);
      }
      return format
        .replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    },


    _getCart: function () {
      return fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); });
    },

    _addToCart: function (variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },

    _removeFromCart: function (lineKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ id: lineKey, quantity: 0 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },


    _esc: function (str) {
      if (str == null) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

  };

  document.addEventListener('DOMContentLoaded', function () {
    MWUpsellEngine.init();
    MWUpsellEngine.initCartPageOffer();
  });

})();
